import { render, staticRenderFns } from "./RemoveReviewConfirmationModal.vue?vue&type=template&id=6830dfb4&"
import script from "./RemoveReviewConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./RemoveReviewConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports